import useSelector from 'modules/component/utils/hooks/useSelector'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import React from 'react'
import { MEDIA_LAYOUT_TYPE } from '@gymaholic/packages'
import getMediaImageProfileByIdSelector from 'modules/profile/redux/selectors/get-media-image-by-id/index.js'
import MediaImage from 'containers/MediaImage/index.js'
import ProfileImage from 'components/ProfileImage/index.js'

export default function ProfileImageMedia (props) {
  const {
    size,
    children,
    id
  } = props
  const media = useSelector(getMediaImageProfileByIdSelector(id))

  return (
    <MediaImage
      id={getIdReduxUtil(media)}
      layoutType={MEDIA_LAYOUT_TYPE.ROW}
      shouldNotShowDefaultImage
      useDefaultImage={false}
    >
      {
        ({ source }) => {
          if (!source && children) {
            return children
          }

          return (
            <ProfileImage
              size={size}
              source={source}
              id={id}
            />
          )
        }
      }
    </MediaImage>
  )
}
